import React from 'react';
import { Link } from 'react-router-dom';
import './ComingSoon.css';

const ComingSoon = ({ serviceName = 'This service', icon = '🚧', tagline }) => {
  return (
    <div className="coming-soon">
      <div className="cs-card">
        <div className="cs-icon">{icon}</div>
        <div className="cs-badge">Coming Soon</div>
        <h2 className="cs-title">{serviceName} is on the way</h2>
        <p className="cs-sub">
          {tagline || `We're polishing ${serviceName.toLowerCase()} in Bihar. Drop your number and we'll ping you when it goes live.`}
        </p>

        <div className="cs-actions">
          <Link to="/" className="cs-btn-primary">
            Book a One-Way Cab instead
          </Link>
          <a href="https://wa.me/919999999999?text=I'm%20interested%20in%20updates%20about%20new%20ZilaCab%20services"
             target="_blank" rel="noopener noreferrer"
             className="cs-btn-ghost">
            Notify me on WhatsApp
          </a>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
